/* eslint-disable no-bitwise */
/* eslint-disable no-inline-comments */
export const RoleType = Object.freeze({
  EMPLOYEE: 'Employee',
  MANAGER: 'Manager',
  SITEADMIN: 'SiteAdmin',
  PARTNER: 'Partner',
  SUPERADMIN: 'SuperAdmin',
});

export const RoleCheck = Object.freeze({
  hasEmployee: 1, // 00001
  hasManager: 1 << 1, // 00010
  hasSiteAdmin: 1 << 2, // 00100
  hasPartner: 1 << 3, // 01000
  hasSuperAdmin: 1 << 4, // 10000
});

export const Feature = Object.freeze({
  reportsAndDayView: 43,
  autoOnboardNewHire: 13,
  autoApplyEssChanges: 12,
  standardScheduling: 11,
  mobileApplication: 10,
  benefitsManagement: 9,
  centeralizedData: 8,
  advancedTime: 7,
  advancedHR: 5,
  platformPricing: 1,
});

export const PermissionType = Object.freeze({
  viewSchedule: 'ViewSchedule',
  viewEmployee: 'ViewEmployee',
  modifySchedule: 'ModifySchedule',
  viewEmployeeRestricted: 'ViewEmployeeRestricted',
  modifyPassword: 'ModifyPassword',
  viewEmployeeContact: 'ViewEmployeeContact',
  modifyEmployeeContact: 'ModifyEmployeeContact',
  modifyEmployee: 'ModifyEmployee',
  modifyEmployeeRestricted: 'ModifyEmployeeRestricted',
  createEmployee: 'CreateEmployee',
  viewWages: 'ViewWages',
  modifyWages: 'ModifyWages',
  modifyPunches: 'ModifyPunches',
  modifyUnmatchedPunches: 'ModifyUnmatchedPunches',
  hubAdmin: 'HubAdmin',
  onboardingAdmin: 'OnboardingAdmin',
  benefitsAdmin: 'BenefitsAdmin',
  viewRoles: 'ViewRoles',
  modifyRoles: 'ModifyRoles',
  viewSettings: 'ViewSettings',
  modifyPunchCategories: 'ModifyPunchCategories',
  deletePunchCategories: 'DeletePunchCategories',
  viewRegisteredClocks: 'ViewRegisteredClocks',
  modifyRegisteredClocks: 'ModifyRegisteredClocks',
  registerClocks: 'RegisterClocks',
  viewBiometrics: 'ViewBiometrics',
  modifyBiometrics: 'ModifyBiometrics',
});

export const PermissionLevel = Object.freeze({
  none: 'None',
  self: 'Self',
  all: 'All',
  directReports: 'DirectReports',
  selfAndDirectReports: 'SelfAndDirectReports',
});

export const PermissionKeys = Object.keys(PermissionLevel);

export const NoPermissions = PermissionKeys.reduce((obj, key) => {
  return { ...obj, [key]: false };
}, {});
